// $(document).ready(function () {
//   // Initialize Slick sliders for each element with the class "slider"
//   $(".js-image-slider").each(function () {
//     $(this).slick({
//       infinite: true,
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: false,
//       centerMode: true,
//       autoplay: true,
//       autoplaySpeed: 2000,
//       responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//           },
//         },
//         {
//           breakpoint: 300,
//           settings: "unslick",
//         },
//       ],
//     });
//   });
// });



// // Function to update the min and max values based on the input
// var Shopify2 = Shopify2 || {};
// (Shopify2.money_format = "${{amount}}"),
//   (Shopify2.formatMoney = function (cents, format) {
//     typeof cents == "string" && (cents = cents.replace(".", ""));
//     var value = "",
//       placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
//       formatString = format || this.money_format;
//     function defaultOption(opt, def) {
//       return typeof opt > "u" ? def : opt;
//     }
//     function formatWithDelimiters(number, precision, thousands, decimal) {
//       if (
//         ((precision = defaultOption(precision, 2)),
//         (thousands = defaultOption(thousands, ",")),
//         (decimal = defaultOption(decimal, ".")),
//         isNaN(number) || number == null)
//       )
//         return 0;
//       number = (number / 100).toFixed(precision);
//       var parts = number.split("."),
//         dollars = parts[0].replace(
//           /(\d)(?=(\d\d\d)+(?!\d))/g,
//           "$1" + thousands
//         ),
//         cents2 = parts[1] ? decimal + parts[1] : "";
//       return dollars + cents2;
//     }
//     switch (formatString.match(placeholderRegex)[1]) {
//       case "amount":
//         value = formatWithDelimiters(cents, 2);
//         break;
//       case "amount_no_decimals":
//         value = formatWithDelimiters(cents, 0);
//         break;
//       case "amount_with_comma_separator":
//         value = formatWithDelimiters(cents, 2, ".", ",");
//         break;
//       case "amount_no_decimals_with_comma_separator":
//         value = formatWithDelimiters(cents, 0, ".", ",");
//         break;
//     }
//     return formatString.replace(placeholderRegex, value);
//   });
// // End of SHopify format

// function updateMinMaxVal(event) {
//   var $this = $(this);
//   let value = parseInt(event.target.value, 10); // Ensure it's an integer
//   const prevMinValue = parseInt(event.target.getAttribute("min"), 10);
//   const prevMaxValue = parseInt(event.target.getAttribute("max"), 10);
//   // add funciton herre
//   let newMin, newMax;

//   // Determine new min and max based on value
//   if (!$(".range_bar").hasClass('disable')){
//   if (value >= 100 && value < 250 ) {
//     newMin = Math.max(100, 1);
//     newMax = Math.min(250, 250);
//      $(".range_bar").addClass('disable');

//   } else if (value >= 250 && value <= 500) {
//     newMin = Math.max(250, 250);
//     newMax = Math.min(500, 500);
//         $(".range_bar").addClass('disable');
//   } else {
//     newMin = Math.max(1, 1);
//     newMax = Math.min(100, 250);
//   }
//     console.log(newMin,newMax, value)
//   }
//   if (newMin !== prevMinValue || newMax !== prevMaxValue) {
//     $(".min_value span").text(newMin);
//     $(".max_value span").text(newMax);
//     setTimeout(function(){
//       $(".range_bar").removeClass('disable');
//     },1200) 
//     // Update slider attributes
//     $this.attr("min", newMin).attr("max", newMax);
//   }
//   $this.val(value);
//   $(".range-with-quanity .quantity__input").val(value);
//   // Calculate the percentage progress
//   var min2 = parseInt($this.attr("min")),
//     max2 = parseInt($this.attr("max")),
//     progress = convertToPercentage(value, min2, max2);

//   // Update progress bar background using percentage
//   $this.each(function () {
//     this.style.background = `linear-gradient(to right, #fff ${progress}%, transparent ${progress}%)`;
//   });
//    updateUnitTotal()
// }

// // Function to convert the value to a percentage
// function convertToPercentage(currentValue, minValue, maxValue) {
//   return ((currentValue - minValue) / (maxValue - minValue)) * 100;
// }

// // Event handler for changes on the input element
// $(document).on(
//   "change input keyup",
//   ".product__info-container .product_bulk_hour",
//   function (e) {
//     var $this = $(this),
//       current_val = parseInt($this.val()); // Parse to ensure it's an integer
//     var $quantityInput = $(".range-with-quanity .quantity__input");

//     adjustRangeBar(current_val); // Update the range bar with the current value
//     // Handle default values when the current value is invalid
//     if (current_val === "" || current_val <= 0) {
//       $quantityInput.val(1).change(); // Set to 1 if the value is empty or invalid
//     } else if (current_val > 500) {
//       $quantityInput.val(500).change(); // Set to 500 if the value is greater than 500
//     } else {
//       $quantityInput.val(current_val); // Set to the valid current value
//     }
//     PDPlockPrice($quantityInput.val());
//     updateUnitTotal()
//   }
// );

// // Function to adjust the range bar based on the current value
// function adjustRangeBar(curValue) {
//   // Cache frequently accessed DOM elements
//   var $productRangebar = $(".product_rangebar"),
//     $quantityInput = $(".range-with-quanity .quantity__input"),
//     $minEle = $("#min_range_value span"),
//     $maxEle = $("#max_range_value span");

//   // Ensure curValue is a number
//   curValue = parseInt(curValue);
//   // Update min and max attributes only if they changed
//   var currentMaxVal = parseInt($productRangebar.attr("max"));
//   var currentMinVal = parseInt($productRangebar.attr("min"));
//   // Determine new min/max range based on the current value
//   let newMin, newMax;
//   if (curValue >= 100 && curValue < 250) {
//     newMin = curValue === 100 ? 1 : 100;
//     newMax = 250;
//   } else if (curValue >= 250 && curValue <= 500) {
//     newMin = curValue === 250 ? 100 : 250;
//     newMax = 500;
//   } else {
//     newMin = 1;
//     newMax = 100;
//   }

//   if (newMin !== currentMinVal) {
//     $minEle.text(newMin);
//     $maxEle.text(newMax);

//     $productRangebar.attr("min", newMin).attr("max", newMax);
//   }
//   $productRangebar.val(curValue);
//   $quantityInput.val(curValue);

//   // Calculate the percentage progress
//   var min2 = parseInt($productRangebar.attr("min")),
//     max2 = parseInt($productRangebar.attr("max")),
//     progress = convertToPercentage(curValue, min2, max2);

//   // Update progress bar background using percentage
//   $productRangebar.each(function () {
//     this.style.background = `linear-gradient(to right, #fff ${progress}%, transparent ${progress}%)`;
//   });
//   updateUnitTotal()
// }
// // Cache the product range sliders and add event listeners
// $(document).ready(function () {
//   $(".product_rangebar").on("input", updateMinMaxVal); // jQuery event handler
//   updateUnitTotal()
// });





// //Chnagae the price and apply the discount
// function calculateDiscount(pricePerUnit, discountPercentage, hours) {
//   console.log("priceperUnit",pricePerUnit, hours)
//     if (hours > 4) {
//         const discount = pricePerUnit * discountPercentage / 100;
//         const totalAfterDiscount = Math.ceil((pricePerUnit - discount) * hours).toFixed(2); // Round up and keep 2 decimal places
//         const totalDiscount = (pricePerUnit * discountPercentage / 100 * hours).toFixed(2);
//         return { discount, totalAfterDiscount, totalDiscount, totalComparedPrice: (pricePerUnit * hours).toFixed(2) };
//     } else {
//         const totalAfterDiscount = Math.ceil(pricePerUnit * hours).toFixed(2); // Round up and keep 2 decimal places
//         return { discount: pricePerUnit, totalAfterDiscount, totalDiscount: "0.00", totalComparedPrice: (pricePerUnit * hours).toFixed(2) };
//     }
// }

// function updateUnitTotal() {
//   const hrs = parseInt($(".quantity__input.product_bulk_hour").val());
//   let price = 0,
//     sub_price = 0;
//   var pricePerHour = $(".current-selected-varaint .variant--price").attr('data-price') || 50;

//      const tiers = {
//             10: 0,
//             30: parseInt($(".pro_discount .qty_discount_2").attr("data_discount")),
//             500: parseInt($(".pro_discount .qty_discount_3").attr("data_discount"))
//         };

//     // Get tier discount based on hours
//     const getTierDiscount = (tiers, hours) => {
//         for (let v of Object.keys(tiers)) {
  
//             if (v > hours) {
//                 return tiers[v];
//             }
//         }
//         return 0;
//     };

// // const $discountbanner = $(".price_discount_container");
// // const $priceContainer = $(".price__container .price_regular");
// const $priceContainer = $(".price-main-regular");
//   const $discountbanner = $(".discount-price-offset");
//   const $priceSaleContainer =  $(".price-sale-container");
// hrs < 10 ? (
//     $discountbanner.addClass("hidden"),
//     $priceContainer.addClass("hidden"),
//   $priceSaleContainer.removeClass("active")
// ) : (
//     $discountbanner.removeClass("hidden"),
//     $priceContainer.removeClass("hidden"),
//     $priceSaleContainer.addClass("active")
// );
//      onetimeprice = getTierDiscount(tiers, hrs);
//    const productDiscounts = calculateDiscount(pricePerHour, onetimeprice, hrs);
//   const perHourAfterDiscount= (productDiscounts.totalAfterDiscount / hrs).toFixed(2)

//      // Update price elements
//     $(".price_per_single span").html(Shopify2.formatMoney(productDiscounts.totalAfterDiscount * 100, ""));
//     $(".price_label_pricing span").html(Shopify2.formatMoney(productDiscounts.discount * 100, ""));


//    $(".variant-per-qty-sale span").html(Shopify2.formatMoney(perHourAfterDiscount, ""));
//     $(".variant-total-sale").html(Shopify2.formatMoney(productDiscounts.totalAfterDiscount, ""));
//     $(".discount_price").html(Shopify2.formatMoney(productDiscounts.totalDiscount, ""));
//     $(".discount-price-offset span").html(onetimeprice);
//     $(".variant--total-price").html(Shopify2.formatMoney(productDiscounts.totalComparedPrice * 100, ""));
//     $(".button_price").html( Shopify2.formatMoney(productDiscounts.totalAfterDiscount, ""));

// }
// function PDPlockPrice(current_val) {
//   const currentVariantPrice = $(".variant--price").attr("data-price");

//   var price_per_product_sale = currentVariantPrice * current_val;

//   $(".product-form__submit .button_price").html(
//     Shopify2.formatMoney(price_per_product_sale * 100, "")
//   );
//   // var price_per_product_regular = parseFloat($(".price_per_qty_sale").attr("data-compare-price")) * current_val;
//   // $(".price_per_product_regular span").html(Shopify2.formatMoney(price_per_product_regular * 100, ""));
//   // var total_discount = price_per_product_regular - price_per_product_sale;
//   // $(".discount_price").html(Shopify2.formatMoney(total_discount * 100, "")),
//   // current_val <= 100 ? updateLockOutput(current_val) : current_val <= 250 ? updateLockOutputWithIncrement(current_val, 100, 1) : current_val <= 500 && updateLockOutputWithIncrement(current_val, 250, 1);
//   // var max2 = parseInt($(".product_rangebar_lock_in").attr("max"))
//   //   , min2 = parseInt($(".product_rangebar_lock_in").attr("min"));
// }

//  document.addEventListener("DOMContentLoaded", function() {
//   const marquee = document.querySelector('.solution_inner');
//   const lists = document.querySelectorAll('.solution_marquee .lists');

//   // Check if there are lists present
//   if (lists.length > 0) {
//     const totalWidth = Array.from(lists).reduce((total, item) => total + item.offsetWidth, 0);
    
//     // Set the animation duration dynamically based on the total width of all items
//     const animationDuration = totalWidth / 50; // Adjust 50 to change the speed
//     marquee.style.animationDuration = `${animationDuration}s`;
//   }
// });

//   function openCalendlyPopup(e) {
//     if (e) e.preventDefault();
//     Calendly.initPopupWidget({
//       url: 'https://calendly.com/aashish-sachdeva-swiftexpand/30min?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=008060'
//     });
//     return false;
//   }


$(document).ready(function () {
  $(".js-image-slider").each(function () {
    $(this).slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 300,
          settings: "unslick",
        },
      ],
    });
  });
});
  let lastProgress = 0;
  let isFirstLoad = true;
  let isFromButton = false;
  function setTooltipPosition(progress) {
  const px = 12 - (progress * 27 / 100);
  const $tooltip = $('#cstmrangeTooltipValue').closest('.active_range_bar_tooltip');
  $tooltip.css('left', `calc(${progress}% + ${px}px)`);
  const tiltFactor = (progress - 50) / 50;
  const maxTilt = 15;
  const rotate = tiltFactor * maxTilt;
  let scale = 1 + (progress / 100) * 0.15; 
  let direction = 0;
if (!isFirstLoad) {
  if (progress > lastProgress) {
    direction = 1;
  } else if (progress < lastProgress) {
    direction = -1;
  }
}
let finalRotate = 0;
if (direction > 0) {
  finalRotate = -30;   
} else if (direction < 0) {
  finalRotate = 30;    
}
let translateX = '-50%'; 

if (isFromButton) {
  // 👉 Button click (+ / -)
  if (direction > 0) {
    translateX = '-50%';
  } else if (direction < 0) {
    translateX = '-50%';
  }
} else {
  // 👉 Drag
  if (direction > 0) {
    translateX = '-80%';
  } else if (direction < 0) {
    translateX = '-10%';
  }
}
if (!isFromButton && !isFirstLoad) {
  // 👉 Drag ke time rotate
  $tooltip.css('transform', `translateX(${translateX}) rotate(${finalRotate}deg) scale(${scale})`);
  $tooltip.find('span').css('transform', `rotate(${finalRotate}deg) scale(${scale})`);
} else {
  // 👉 First load + button click → no rotate
  $tooltip.css('transform', `translateX(-50%) scale(1)`);
  $tooltip.find('span').css('transform', `rotate(0deg) scale(1)`);
}
const $dragText = $('.custom_drag_main');

if (isFromButton) {
  // 👉 Button click → always show
  $dragText.show();
} else {
  // 👉 Drag ke time hide/show based on rotate
  if (finalRotate !== 0) {
    $dragText.hide();
  } else {
    $dragText.show();
  }
}

lastProgress = progress;
isFromButton = false;
isFirstLoad = false;
  $('.bulk-hours-wrapper').css('transform', `rotate(${rotate}deg)`);
}
var Shopify2 = Shopify2 || {};
(Shopify2.money_format = "${{amount}}"),
  (Shopify2.formatMoney = function (cents, format) {
    typeof cents == "string" && (cents = cents.replace(".", ""));
    var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || this.money_format;
    function defaultOption(opt, def) {
      return typeof opt > "u" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (
        ((precision = defaultOption(precision, 2)),
        (thousands = defaultOption(thousands, ",")),
        (decimal = defaultOption(decimal, ".")),
        isNaN(number) || number == null)
      )
        return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  });
function updateMinMaxVal(event) {
  var $this = $(this);
  let value = parseInt(event.target.value, 10);
  if (value < 0) value = 0; 
  if (value > 100) value = 100;
  $this.val(value);
  $(".range-with-quanity .quantity__input").val(value);
  $(".custom_main_quantity").val(value);
  $(".hour_calculation").text(value);
  $('#cstmrangeTooltipValue').text(value);
  let progress = value;
  this.style.background = `linear-gradient(to right, #000 ${progress}%, transparent ${progress}%)`;
  setTooltipPosition(progress);
  updateUnitTotal();
}
function convertToPercentage(currentValue, minValue, maxValue) {
  return ((currentValue - minValue) / (maxValue - minValue)) * 100;
}

$(document).on(
  "change input keyup",
  ".product__info-container .product_bulk_hour",
  function (e) {
    isFromButton = true; 
    var $this = $(this),
      current_val = parseInt($this.val()); 
      current_val = isNaN(current_val) ? 0 : current_val;

// ✅ LIMIT FIX
if (current_val < 0) current_val = 0;
if (current_val > 100) current_val = 100;

// input ko bhi update karo (warna UI me 101 dikhega)
$this.val(current_val);
    var $quantityInput = $(".range-with-quanity .quantity__input");
    var $calculateHours = $(".hour_calculation");
    adjustRangeBar(current_val); 
    if (current_val === "" || current_val <= 0) {
      $quantityInput.val(1).change(); 
    }else if (current_val > 100) {
  $quantityInput.val(100).change();
  } else {
      $quantityInput.val(current_val); 
    }
    PDPlockPrice($quantityInput.val());
    updateUnitTotal()
    $calculateHours.text(current_val);
    $('#cstmrangeTooltipValue').text(current_val);
  }
);
function adjustRangeBar(curValue) {
  var $range = $(".product_rangebar");
  curValue = parseInt(curValue);
  if (curValue < 1) curValue = 1;
  if (curValue > 100) curValue = 100;
  $range.val(curValue);
  $(".quantity__input").val(curValue);
  let progress = curValue;
  $range.each(function () {
    this.style.background = `linear-gradient(to right, #000 ${progress}%, transparent ${progress}%)`;
  });
  setTooltipPosition(progress);
}
$(document).ready(function () {
  $(".product_rangebar").on("input", updateMinMaxVal);
  updateUnitTotal()
});
function calculateDiscount(pricePerUnit, discountPercentage, hours) {
  console.log("priceperUnit",pricePerUnit, hours)
   if (discountPercentage > 0) {
        const discount = pricePerUnit * discountPercentage / 100;
        const totalAfterDiscount = Math.ceil((pricePerUnit - discount) * hours).toFixed(2); 
        const totalDiscount = (pricePerUnit * discountPercentage / 100 * hours).toFixed(2);
        return { discount, totalAfterDiscount, totalDiscount, totalComparedPrice: (pricePerUnit * hours).toFixed(2) };
    } else {
        const totalAfterDiscount = Math.ceil(pricePerUnit * hours).toFixed(2); 
        return { discount: pricePerUnit, totalAfterDiscount, totalDiscount: "0.00", totalComparedPrice: (pricePerUnit * hours).toFixed(2) };
    }
}
function updateUnitTotal() {
  // ✅ SINGLE SOURCE VALUE (IMPORTANT)
  let hrs = parseInt($(".product_bulk_hour").val());

  if (isNaN(hrs)) hrs = 1;
  if (hrs < 0) hrs = 0;
  if (hrs > 100) hrs = 100;

  var pricePerHour = $(".current-selected-varaint .variant--price").attr('data-price') || 50;

  const $priceContainer = $(".price-main-regular");
  const $discountbanner = $(".discount-price-offset");
  const $priceSaleContainer = $(".price-sale-container");

  // ✅ SHOW / HIDE
  if (hrs < 10) {
    $discountbanner.addClass("hidden");
    $priceContainer.addClass("hidden");
    $priceSaleContainer.removeClass("active");
  } else {
    $discountbanner.removeClass("hidden");
    $priceContainer.removeClass("hidden");
    $priceSaleContainer.addClass("active");
  }

  // ✅ FINAL DISCOUNT LOGIC (CLEAN)
  let onetimeprice = 0;

  if (hrs >= 30) {
    onetimeprice = 20;
  } else if (hrs >= 10) {
    onetimeprice = 10;
  } else {
    onetimeprice = 0;
  }

  console.log("hrs:", hrs, "discount:", onetimeprice);

  const productDiscounts = calculateDiscount(pricePerHour, onetimeprice, hrs);
  const perHourAfterDiscount = (productDiscounts.totalAfterDiscount / hrs).toFixed(2);

  $(".price_per_single span").html(Shopify2.formatMoney(productDiscounts.totalAfterDiscount * 100, ""));
  $(".price_label_pricing span").html(Shopify2.formatMoney(productDiscounts.discount * 100, ""));
  $(".variant-per-qty-sale span").html(Shopify2.formatMoney(perHourAfterDiscount, ""));
  $(".variant-total-sale").html(Shopify2.formatMoney(productDiscounts.totalAfterDiscount, ""));
  $(".discount_price").html(Shopify2.formatMoney(productDiscounts.totalDiscount, ""));
  $(".discount-price-offset span").html(onetimeprice);
  $(".variant--total-price").html(Shopify2.formatMoney(productDiscounts.totalComparedPrice * 100, ""));
  $(".button_price").html(Shopify2.formatMoney(productDiscounts.totalAfterDiscount, ""));
}
function PDPlockPrice(current_val) {
  const currentVariantPrice = $(".variant--price").attr("data-price");
  var price_per_product_sale = currentVariantPrice * current_val;
  $(".product-form__submit .button_price").html(
    Shopify2.formatMoney(price_per_product_sale * 100, "")
  );
}
 document.addEventListener("DOMContentLoaded", function() {
  const marquee = document.querySelector('.solution_inner');
  const lists = document.querySelectorAll('.solution_marquee .lists');
  if (lists.length > 0) {
    const totalWidth = Array.from(lists).reduce((total, item) => total + item.offsetWidth, 0);
    const animationDuration = totalWidth / 50; // Adjust 50 to change the speed
    marquee.style.animationDuration = `${animationDuration}s`;
  }
});
  function openCalendlyPopup(e) {
     location.href="/#lead-form"
  }
  document.addEventListener('DOMContentLoaded', function () {
  const dragLabel = document.querySelector('.custom_drag_main');
  const rangeInput = document.querySelector('#product_range');
  const $tooltip = $('#cstmrangeTooltipValue').closest('.active_range_bar_tooltip');
  if (!dragLabel || !rangeInput) return;
  dragLabel.classList.add('is-blinking');
  const startDrag = () => {
    dragLabel.classList.add('is-dragging');
    dragLabel.classList.remove('is-blinking');
  };
  const endDrag = () => {
    dragLabel.classList.remove('is-dragging');
    dragLabel.classList.add('is-blinking');
     $tooltip.css('transform', 'translateX(-50%) scale(1)');
    $tooltip.find('span').css('transform', 'rotate(0deg) scale(1)');
    $('.custom_drag_main').show();
  };

  
  rangeInput.addEventListener('mousedown', startDrag);
  rangeInput.addEventListener('touchstart', startDrag);
  rangeInput.addEventListener('mouseup', endDrag);
  rangeInput.addEventListener('touchend', endDrag);
});
  $(document).ready(function () {
  let defaultVal = 30;

  // ✅ FORCE SYNC ALL INPUTS
  $(".product_bulk_hour").val(defaultVal);
  $(".quantity__input").val(defaultVal);
  $(".product_rangebar").val(defaultVal);

  $(".hour_calculation").text(defaultVal);
  $('#cstmrangeTooltipValue').text(defaultVal);

  $(".product_rangebar").each(function () {
    this.style.background = `linear-gradient(to right, #000 ${defaultVal}%, transparent ${defaultVal}%)`;
  });

  setTooltipPosition(defaultVal);

  // ✅ IMPORTANT: update AFTER setting
  updateUnitTotal();
});

$(document).ready(function () {
  const defaultVal = 30;

  // ✅ Reset storage once (optional)
  localStorage.removeItem('bulk_hours');
  sessionStorage.removeItem('bulk_hours');

  // ✅ Sync all inputs (single line)
  $(".product_bulk_hour, .quantity__input, .product_rangebar").val(defaultVal);

  // ✅ Update text
  $(".hour_calculation, #cstmrangeTooltipValue").text(defaultVal);

  // ✅ Range background
  $(".product_rangebar").each(function () {
    this.style.background = `linear-gradient(to right, #000 ${defaultVal}%, transparent ${defaultVal}%)`;
  });

  // ✅ Tooltip + price update
  setTooltipPosition(defaultVal);
  updateUnitTotal();
});

// $(document).on('click', '.cstm_btn_bulk .product-form__submit', function () {
//   const $btn = $(this);

//   $btn.addClass('loading');

//   const $spinner = $btn.find('.loading__spinner');

//   // hidden remove + force show
//   $spinner.removeClass('hidden');
//   $spinner[0].style.setProperty('display', 'inline-flex', 'important');
// });
document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth < 750) {

    const originalBtn = document.querySelector(".product-form__buttons");

    if (!originalBtn) return;

    // clone create
    const stickyBtn = originalBtn.cloneNode(true);
    stickyBtn.classList.add("sticky-clone-btn");

    document.body.appendChild(stickyBtn);

    // scroll logic
    window.addEventListener("scroll", function () {

      const rect = originalBtn.getBoundingClientRect();

      if (rect.top < 0) {
        stickyBtn.classList.add("show");
      } else {
        stickyBtn.classList.remove("show");
      }

    });

  }


  
   // testimonial readmore readless
  document.querySelectorAll('.custom-read-toggle').forEach(btn => {
  btn.addEventListener('click', function() {
    const text = this.previousElementSibling;

    text.classList.toggle('expanded');

    if (text.classList.contains('expanded')) {
      this.textContent = 'Read Less';
    } else {
      this.textContent = 'Read More';
    }
  });
});

});